<app-top>
  <h1>Din besättning</h1>
  <h2>Få råd utifrån ditt nuläge</h2>
</app-top>

<form class="form" [formGroup]="form" (submit)="onSubmitForm()">
  <div class="boxes">
    <fieldset>
      <div class="box">
        <h3 class="title">Nuvarande celltal</h3>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd1" [value]="HerdCells.Below" formControlName="cells" />
          <label class="form-check-label" for="rd1">Under 300 000</label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd2" [value]="HerdCells.Above" formControlName="cells" />
          <label class="form-check-label" for="rd2">Över 300 000</label>
        </div>
        <div class="emergency" [class.hidden]="!showEmergency">
          <a [routerLink]="emergencyLink" appButton variant="warning">Se akutåtgärder</a>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <div class="box">
        <h3 class="title">Mjölkningssystem</h3>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd3" [value]="HerdMilking.Conventional" formControlName="milking" />
          <label class="form-check-label" for="rd3">Konventionell</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd4" [value]="HerdMilking.Robot" formControlName="milking" />
          <label class="form-check-label" for="rd4">Robot</label>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <div class="box">
        <h3 class="title">Typ av bakterier</h3>

        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd5" [value]="HerdBacteria.Cow" formControlName="bacteria" />
          <label class="form-check-label" for="rd5">
            Mest kobundna<br />
            <em>(t ex. Staf aureus, Strep agalactiae)</em>
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd6" [value]="HerdBacteria.Environmental" formControlName="bacteria" />
          <label class="form-check-label" for="rd6">
            Mest miljöbakterier<br />
            <em>(t ex. Strep uberis, E coli)</em>
          </label>
        </div>

        <div class="form-check">
          <input class="form-check-input" type="radio" id="rd7" [value]="HerdBacteria.Unknown" formControlName="bacteria" />
          <label class="form-check-label" for="rd7">Vet ej</label>
        </div>
      </div>
      <button type="submit" appButton class="primary-btn" [class.disabled]="!form.valid">Se förslag</button>
    </fieldset>
  </div>
</form>
